module.exports = __webpack_public_path__ + "static/media/en-US.fb367a2e.md";